import React from "react";
import * as styles from "./Info.module.scss";
import classNames from "classnames";
import Icon from "@app/components/Icon";
import PropTypes from "prop-types";

const Info = ({ icon, iconSize = 64, copy, className, isError = false, isWarning = false, headline }) => {
	const infoClassName = classNames({
		[styles["info"]]: true,
		[styles["info--error"]]: isError,
		[styles["info--warning"]]: isWarning,
		[className]: !!className,
	});

	return (
		<div className={infoClassName}>
			<div className={styles["header"]}>
				<Icon icon={icon} size={iconSize} />
				{headline && <span className={classNames("ml-12 text-big font-bold")}>{headline}</span>}
			</div>
			{copy && <div className={styles["copy"]}>{copy}</div>}
		</div>
	);
};

Info.propTypes = {
	icon: PropTypes.string.isRequired,
	iconSize: PropTypes.number,
	copy: PropTypes.string.isRequired,
	className: PropTypes.string,
	isError: PropTypes.bool,
	isWarning: PropTypes.bool,
};

export default Info;
